export default __webpack_public_path__ + "static/media/feintattack1.7772ff10.png";